import { PokemonSprite } from "@/components/pokemon/pokemon-sprite";
import { isXsScreen } from "@/utils/screen-size-check";
import { Direction } from "types/battle-engine/battle";

interface TeamSpritesDisplayProps {
  team: Array<{
    id: number;
    base_pokemon_name: string;
    [key: string]: any;
  }>;
}

/**
 * Simple horizontal display of team sprites only - no borders, no names, pure sprites.
 */
export function TeamSpritesDisplay({ team }: TeamSpritesDisplayProps) {
  return (
    <div className="grid grid-cols-4 items-center justify-center gap-0 max-w-sm">
      {team.map((pokemon, index) => {
        return (
          <div key={pokemon.id} className="relative">
            <PokemonSprite
              pokemon={pokemon}
              className="w-9 h-9"
              style={{ scale: isXsScreen() ? 4 : 3 }}
              ignoreScale={true}
              direction={Direction.S}
              showShadow
            />
          </div>
        );
      })}
    </div>
  );
}
